export default __webpack_public_path__ + "static/media/msi.9414444e.jpg";